function closeAllBlocks() {
  document.querySelectorAll('.accordion-row').forEach((bodyElement) => {
    bodyElement.classList.remove('open');
  });
}

window.onload = (event) => {
  const accordion = document.querySelector('.product-accordion .desc'); // jonbit 1.1 changed .metafield-rich_text_field to .desc
  const productAccordion = document.querySelector('.product-accordion');

  if (!accordion || !productAccordion) return;

  const blocks = [];

  // Nur Element-Knoten (keine Text-/Whitespace-Knoten)
  Array.from(accordion.children).forEach((el) => {
    const isTitle = el.firstElementChild?.tagName === 'STRONG';

    if (isTitle) {
      blocks.push({ type: 'title', value: el.innerText.trim() });
      return;
    }

    const html = nodeToHTML(el);
    if (!html) return;

    const last = blocks[blocks.length - 1];
    if (last && last.type === 'content') {
      last.value += html;
    } else {
      blocks.push({ type: 'content', value: html });
    }
  });

  // Falls Content vor einem Titel steht, einen Default-Titel einfügen
  if (blocks.length && blocks[0].type === 'content') {
    blocks.unshift({ type: 'title', value: 'Details' });
  }

  let content = '';

  blocks.forEach((block) => {
    if (block.type === 'title') {
      content += '<div class="accordion-row">';
      content += `<div class="accordion-header">${block.value}</div>`;
    } else {
      content += `<div class="accordion-body">${block.value}</div></div>`;
    }
  });

  productAccordion.innerHTML = content;

  document.querySelectorAll('.accordion-header').forEach((headerElement) => {
    headerElement.onclick = () => {
      const open = headerElement.parentElement.classList.contains('open');
      closeAllBlocks();

      if (!open) {
        headerElement.parentElement.classList.add('open');
      }
    };
  });

  // --- Helper: Elemente korrekt serialisieren ---
  function nodeToHTML(el) {
    if (!el.tagName) return '';
    const tag = el.tagName.toUpperCase();

    switch (tag) {
      case 'P':
        return el.innerHTML ? `<p>${el.innerHTML}</p>` : '';
      case 'TABLE':
      case 'UL':
      case 'OL':
      case 'PRE':
      case 'BLOCKQUOTE':
      case 'DIV':
        // Block-Elemente nicht in <p> einwickeln
        return el.outerHTML;
      default:
        // Fallback: wie Absatz behandeln
        return el.innerHTML?.trim() ? `<p>${el.innerHTML}</p>` : '';
    }
  }
};
